// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-state-selector__trigger {
  font-family: var(--font-secondary);
  cursor: pointer;
  position: relative;
  height: 1.188rem;
  min-width: 9.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ion-color-light);
  border-radius: 0.25rem;
}
.navbar-state-selector__trigger p {
  margin: 0 0.5rem;
  color: var(--ion-color-light);
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
}
.navbar-state-selector__trigger ion-icon {
  position: absolute;
  right: 0.5rem;
}

ion-popover.navbar-state-selector__popover {
  --backdrop-opacity: 0.6;
  --box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.6);
  --color: var(--ion-color-light);
  --width: 9.375rem;
  --border-radius: 0.5rem;
}

ion-popover.navbar-state-selector__popover ion-content {
  --background: #00334d;
  --color: var(--ion-color-light);
  padding: 2rem 1rem;
  border: 1px solid var(--ion-color-light);
  border-radius: 0.5rem;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
}

ion-popover.navbar-state-selector__popover::part(backdrop) {
  background-color: rgba(0, 0, 0, 0.4);
}

.navbar-state-selector__item {
  margin: 0.5rem;
  font-family: var(--font-secondary);
  cursor: pointer;
  text-align: center;
  position: relative;
}
.navbar-state-selector__item.active {
  color: var(--ion-color-secondary) !important;
}
.navbar-state-selector__item.active ion-icon {
  color: var(--ion-color-secondary) !important;
  margin-left: 0.25rem;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/app/components/navbar-state-selector/navbar-state-selector.component.scss"],"names":[],"mappings":"AAAA;EACI,kCAAA;EACA,eAAA;EACA,kBAAA;EAEA,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,wCAAA;EACA,sBAAA;AAFJ;AAII;EACI,gBAAA;EACA,6BAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAFR;AAKI;EACI,kBAAA;EACA,aAAA;AAHR;;AAOA;EAEI,uBAAA;EACA,6CAAA;EACA,+BAAA;EACA,iBAAA;EACA,uBAAA;AALJ;;AAQA;EACI,qBAAA;EACA,+BAAA;EACA,kBAAA;EACA,wCAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AALJ;;AAQA;EACI,oCAAA;AALJ;;AAQA;EACI,cAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AALJ;AAOI;EACI,4CAAA;AALR;AAOQ;EACI,4CAAA;EACA,oBAAA;EACA,kBAAA;AALZ","sourcesContent":[".navbar-state-selector__trigger {\n    font-family: var(--font-secondary);\n    cursor: pointer;\n    position: relative;\n\n    height: 1.188rem;\n    min-width: 9.375rem;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    border: 1px solid var(--ion-color-light);\n    border-radius: 0.25rem;\n\n    p {\n        margin: 0 0.5rem;\n        color: var(--ion-color-light);\n        text-transform: uppercase;\n        font-size: 0.7rem;\n        font-weight: 700;\n    }\n\n    ion-icon {\n        position: absolute;\n        right: 0.5rem;\n    }\n}\n\nion-popover.navbar-state-selector__popover {\n    //--background: #00334d;\n    --backdrop-opacity: 0.6;\n    --box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.6);\n    --color: var(--ion-color-light);\n    --width: 9.375rem;\n    --border-radius: 0.5rem;\n}\n\nion-popover.navbar-state-selector__popover ion-content {\n    --background: #00334d;\n    --color: var(--ion-color-light);\n    padding: 2rem 1rem;\n    border: 1px solid var(--ion-color-light);\n    border-radius: 0.5rem;\n    text-transform: uppercase;\n    font-size: 0.7rem;\n    font-weight: 700;\n}\n\nion-popover.navbar-state-selector__popover::part(backdrop) {\n    background-color: rgba(0, 0, 0, 0.4);\n}\n\n.navbar-state-selector__item {\n    margin: 0.5rem;\n    font-family: var(--font-secondary);\n    cursor: pointer;\n    text-align: center;\n    position: relative;\n\n    &.active {\n        color: var(--ion-color-secondary) !important;\n\n        ion-icon {\n            color: var(--ion-color-secondary) !important;\n            margin-left: 0.25rem;\n            position: absolute;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
